import React from 'react';
import UsersPage from 'core/views/admin/UsersPage';

const Users = () => <UsersPage />;

export default Users;
